import { Outlet, useLocation } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import { auth } from "./contants/Auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import LoginModal from "./components/LoginModal";
import UnauthorizedModal from "./components/UnauthorizedModal";
import { Box, CircularProgress } from "@mui/material";
import { useState, useEffect} from 'react';


const ALLOWED_DOMAIN = "marketpulse.co.kr";

function App() {
  
  const [user, checking] = useAuthState(auth);
  const [token, setToken] = useState("");
  const location = useLocation(); 
  const [invalidDomain, setInvalidDomain] = useState(false);

  useEffect(() => {
    const fetchToken = async () => {
      if (user) {

        // 이메일 도메인 체크 추가
        const email = user.email;
        if (email && !email.endsWith(`@${ALLOWED_DOMAIN}`)) {
          setInvalidDomain(true);
        }

        const idToken = await user.getIdToken(); // 캐시된 토큰
        setToken(idToken);
      }
    };
    fetchToken();
  }, [user]);

  if (checking || (user && !token)) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const handleLogOut = () => {
    signOut(auth);
    window.location.reload();
  };

  const isMainPage = location.pathname === "/";

  return (
    <>
      {
        !user
          ? <LoginModal />
          : invalidDomain
            ? <UnauthorizedModal handleLogout={handleLogOut}/>
            : isMainPage
              ? <Outlet context={{ token }} />
              : <AppLayout user={user} handleLogOut={handleLogOut}>
                  <Outlet context={{ token }} />
                </AppLayout>
      }
    </>
  );
}

export default App;